import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';
import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../utils/sizes';
import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const TEXT_WIDTH = {
  [HD]: SCREEN_WIDTH[HD] - safetyMargins.horizontal[HD] * 2,
  [FULL_HD]: SCREEN_WIDTH[FULL_HD] - safetyMargins.horizontal[FULL_HD] * 2,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getContainerHeight = screenSize => SCREEN_HEIGHT[screenSize] - safetyMargins.vertical[screenSize] * 2;

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const containerHeight = getContainerHeight(screenSize);

  return {
    alpha: 0,
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Overlay: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      color: colors.background[colorMode],
    },
    ContentContainer: {
      h: containerHeight,
      x: safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      Top: {},
      Scroll: {
        w: TEXT_WIDTH[screenSize],
        h: containerHeight,
        y: 0,
      },
    },
  };
};

export const getProgramInformationFocusedStyle = () => ({
  smooth: {
    alpha: 1,
  },
});

export const getProgramInformationUnFocusedStyle = () => ({
  smooth: {
    alpha: 0,
  },
});
